import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import AllergyActionPlanFormComp from '../../../../components/registrationPacket/AllergyActionPlanFormComp';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { submitAllergyActionPlan } from '../../../../store/allergyActionPlan/allergyActionPlanSlice';
import Swal from 'sweetalert2';

const AllergyActionPlanForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const planData = useSelector(state => id ? state.allergyActionPlan.plans.find(plan => plan.id === parseInt(id)) : null);

  useEffect(() => {
    // Optionally fetch plan if not loaded
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await dispatch(submitAllergyActionPlan(formData)).unwrap();
      await Swal.fire({
        title: 'Success!',
        text: `Allergy Action Plan ${isEditMode ? 'updated' : 'created'} successfully.`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
      navigate('/dashboard/allergy-action-plan/list');
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error || 'Failed to submit allergy action plan.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const handleCancel = () => {
    navigate('/dashboard/allergy-action-plan/list');
  };

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">
                  {isEditMode ? 'Edit' : 'Create'} Allergy/Anaphylaxis Action Plan
                </h4>
              </div>
              <Button variant="secondary" size="sm" onClick={() => navigate('/dashboard/allergy-action-plan/list')}>
                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <AllergyActionPlanFormComp 
                isEditMode={isEditMode} 
                defaultData={planData || {}} 
                onSubmit={handleSubmit}
                onCancel={handleCancel}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllergyActionPlanForm;
